import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import InputPage from './components/InputPage';
import TagsPage from './components/TagsPage';
import CardFlowPage from './components/CardFlowPage';
import './App.css';

function App() {
  // 条件标签映射
  const conditionLabels = {
    appearance: '外貌',
    skin: '皮肤',
    height_min: '最低身高',
    height_max: '最高身高',
    age_min: '最小年龄',
    age_max: '最大年龄',
    personality: '性格',
    annual_income_min: '最低年收入',
    property: '房产',
    education_min: '最低学历',
    parent_education_min: '父母最低学历',
    drinking: '饮酒习惯',
    smoking: '抽烟习惯',
  };

  const [rawConditions, setRawConditions] = useState({});
  const [strictConditions, setStrictConditions] = useState([]);
  const [flexibleConditions, setFlexibleConditions] = useState([]);

  // 处理条件生成
  const handleConditionsGenerated = (conditions) => {
    setRawConditions(conditions);
  };

  // 处理条件更新
  const handleConditionsUpdated = (strict, flexible) => {
    setStrictConditions(strict);
    setFlexibleConditions(flexible);
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<InputPage onConditionsGenerated={handleConditionsGenerated} />} />
        <Route 
          path="/tags" 
          element={
            <TagsPage 
              conditionLabels={conditionLabels} 
              rawConditions={rawConditions}
              onConditionsUpdated={handleConditionsUpdated}
            />
          } 
        />
        <Route 
          path="/cards" 
          element={
            <CardFlowPage 
              strictConditions={strictConditions} 
              flexibleConditions={flexibleConditions} 
            />
          } 
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;